/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';
import PropTypes from 'prop-types';
import { Selector } from './Selector/Selector';
import { DatePicker } from './Calendar/Datepicker';
import { FormMaskedInput, RadioButtons, TextInput } from './Inputs';
import { Calendar } from './Calendar/Calendar';
import { PhoneInput } from './Inputs/PhoneInput';
import { TextArea } from './Inputs/TextArea';
import { Switch } from './Inputs/Switch/Switch';

const Components = {
    radio: RadioButtons,
    selector: Selector,
    datePicker: DatePicker,
    text: TextInput,
    textarea: TextArea,
    // checkbox: Checkbox,
    date: Calendar,
    // date_input: CalendarInput,
    // time: TimeInput,
    mask: FormMaskedInput,
    // number: TextInput,
    phone: PhoneInput,
    // numberInput: NumberInput,
    // periodOfDate: PeriodOfDate,
    // duration: DurationPicker,
    switch: Switch,

};

export const withResolveByType = (View) => {
    // eslint-disable-next-line no-underscore-dangle
    const _withResolveByType = ({
        value, type, noFormatting, onChange, onBlur, ...props
    }) => {
    // eslint-disable-next-line consistent-return
        const handleChange = (e) => {
            switch (type) {
                case 'numberInput':
                    return onChange(e.value);
                case 'selector':
                case 'date':
                case 'radio':
                case 'datePicker':
                case 'switch':
                    return onChange(e);
                case 'password':
                case 'textarea':
                case 'email':
                case 'text':
                case 'mask':
                case 'phone':
                case 'time':
                    return onChange(e.target.value);
                default:
                    break;
            }
        };

        const onBlurHandler = (e) => {
            if (type === 'text' || type === 'textarea') {
                const trimmedValue = e.target.value.trim();
                onChange(trimmedValue);
                // eslint-disable-next-line no-unused-expressions
                onBlur && onBlur(trimmedValue);
            } else if (type === 'date') {
                const eventValue = e?.target?.value;
                const valueToValidate = eventValue !== undefined ? eventValue : value;
                // eslint-disable-next-line no-unused-expressions
                onBlur && onBlur(valueToValidate || '');
            } else if (type === 'phone') {
                // eslint-disable-next-line no-unused-expressions
                onBlur && onBlur(value);
            } else if (type !== 'radio' && type !== 'checkbox' && type !== 'selector') {
                // eslint-disable-next-line no-unused-expressions
                onBlur && onBlur(value);
            }
        };

        const ViewComponent = Components[type] || Components.text;

        return (
            <View
                Component={ViewComponent}
                type={type}
                value={value}
                onChange={handleChange}
                onBlur={onBlurHandler}
                {...props}
            />
        );
    };
    _withResolveByType.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
        value: PropTypes.any,
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        noFormatting: PropTypes.bool,
        onBlur: PropTypes.func,
    };
    _withResolveByType.defaultProps = {
        noFormatting: true,
        onBlur: null,
        value: '',
    };

    return _withResolveByType;
};
